module.exports = __webpack_public_path__ + "static/img/02_ava_network_cornelius_carstens.afc39d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/ava/02_ava_network_cornelius_carstens.png
// module id = ZYvu
// module chunks = 1